module.exports = __webpack_public_path__ + "img/flutter.c433b78a.png";